// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__NVr6G","title":"styles_title__c1lZe","content":"styles_content__HaDRH","footer":"styles_footer__WwOEt","closeIcon":"styles_closeIcon__DUu52"};